export default function SuccessCheck({ size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="success-check"
    >
      <circle
        cx="32"
        cy="32"
        r="30"
        stroke="#b6c6f1"
        strokeWidth="1.5"
        className="success-circle"
      />
      <path
        d="M18 33 L28 43 L46 22"
        stroke="#b6c6f1"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="success-tick"
      />
      <style>{`
        .success-circle {
          stroke-dasharray: 200;
          stroke-dashoffset: 200;
          animation: draw-circle 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .success-tick {
          stroke-dasharray: 60;
          stroke-dashoffset: 60;
          animation: draw-tick 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.55s forwards;
        }
        @keyframes draw-circle { to { stroke-dashoffset: 0; } }
        @keyframes draw-tick { to { stroke-dashoffset: 0; } }
      `}</style>
    </svg>
  );
}
